import { styled } from "@material-ui/core";
import { Link } from "gatsby";

export const PRODUCT_DETAILS_ACTIONS_HEIGHT = "40px";

export const StoreLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  textDecoration: "underline",
  color: theme.palette.text.primary,
  "& svg": {
    marginRight: theme.spacing(0.5)
  },
  "&:hover": {
    color: theme.palette.primary.dark,
    "& svg": {
      color: "none"
    }
  }
}));

export const StoreTextButton = styled("button")(({ theme }) => ({
  fontFamily: "Roobert",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  textDecoration: "underline",
  border: "none",
  outline: "none",
  padding: 0,
  background: "transparent",
  "&:hover": {
    color: theme.palette.primary.dark
  }
}));

export const AddressTextButton = styled("button")(({ theme }) => ({
  fontFamily: "Roobert",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  fontWeight: 600,
  border: "none",
  outline: "none",
  padding: 0,
  background: "transparent",
  "& svg": {
    transform: "translateY(3px)",
    marginRight: theme.spacing(0.25)
  },
  "&:hover": {
    color: theme.palette.primary.dark,
    "& svg path": {
      fill: theme.palette.primary.dark
    }
  }
}));
